import React, { useState } from "react";
import api from "../services/api";
import "./LinkUpload.css";
import { useToast } from "../context/ToastContext";
import { extractErrorMessage } from "../utils/errorUtils";

function LinkUpload({ folderId, onSuccess }) {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const { addToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !url.trim()) {
      addToast("Please enter both name and URL.", "error");
      return;
    }

    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      addToast("URL must start with https:// or http://", "error");
      return;
    }

    setUploading(true);
    try {
      await api.patch(`/folders/${folderId}/add-link`, {
        name,
        url,
      });
      setName("");
      setUrl("");
      addToast("Link added successfully!", "success");
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Failed to add link:", err);
      const errorMessage = await extractErrorMessage(err, "Failed to add link.");
      addToast(errorMessage, "error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <form className="link-upload-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Link name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="text"
        placeholder="https://example.com"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
      <button
        type="submit"
        className="btn btn-primary btn-sm"
        disabled={uploading}
      >
        📎 {uploading ? "Adding..." : "Add Link"}
      </button>
    </form>
  );
}

export default LinkUpload;
